"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _FilterButton = _interopRequireWildcard(require("./FilterButton.style"));

var _Icon = _interopRequireDefault(require("../Icon"));

var renderIcon = function renderIcon(icon) {
  if (!icon) {
    return null;
  }

  if (_react.default.isValidElement(icon)) {
    return icon;
  }

  return _react.default.createElement(_Icon.default, icon);
};

var FilterButton = function FilterButton(props) {
  var iconPosition = props.iconPosition,
      text = props.text,
      children = props.children,
      icon = props.icon,
      theme = props.theme,
      filterCounter = props.filterCounter,
      size = props.size,
      other = (0, _objectWithoutProperties2.default)(props, ["iconPosition", "text", "children", "icon", "theme", "filterCounter", "size"]);
  return _react.default.createElement(_FilterButton.default, (0, _extends2.default)({}, other, {
    size: size
  }), iconPosition === 'left' && renderIcon(icon), text || children, filterCounter > 0 && _react.default.createElement("div", {
    className: (0, _FilterButton.counterLabel)(theme, size)
  }, filterCounter), iconPosition === 'right' && renderIcon(icon));
};

FilterButton.propTypes = {
  text: _propTypes.default.string,
  icon: _propTypes.default.oneOfType([_propTypes.default.shape(_Icon.default.propTypes), _propTypes.default.element]),
  iconPosition: _propTypes.default.oneOf(['left', 'right']),
  style: _propTypes.default.object,
  onClick: _propTypes.default.func,
  disabled: _propTypes.default.bool,
  size: _propTypes.default.oneOf(['medium', 'large']),
  filterOpen: _propTypes.default.bool,
  filterCounter: _propTypes.default.number,
  cssStyle: _propTypes.default.string
};
FilterButton.defaultProps = {
  text: 'Filter',
  icon: {
    type: 'filter',
    style: {
      width: '12px',
      marginRight: '6px'
    }
  },
  iconPosition: 'left',
  style: {},
  onClick: function onClick() {},
  disabled: false,
  type: 'bordered',
  borderType: 'solid',
  size: 'large',
  status: 'normal',
  filterActive: false,
  filterOpen: false,
  filterCounter: 0,
  cssStyle: ''
};

var _default = (0, _emotionTheming.withTheme)(FilterButton);

exports.default = _default;